import { render, staticRenderFns } from "./imprRelationTag.vue?vue&type=template&id=1486498e"
import script from "./imprRelationTag.vue?vue&type=script&lang=js"
export * from "./imprRelationTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1486498e')) {
      api.createRecord('1486498e', component.options)
    } else {
      api.reload('1486498e', component.options)
    }
    module.hot.accept("./imprRelationTag.vue?vue&type=template&id=1486498e", function () {
      api.rerender('1486498e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprRelationTag.vue"
export default component.exports